import { Box, Fade, Slide, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import StoreIcon from '@mui/icons-material/Store';
import { KeyboardArrowDown, LocalActivityOutlined, LocationOnSharp } from '@mui/icons-material';
import Images from '../utils/Images';
import { useNavigate } from 'react-router-dom';
import { SearchBar } from './SearchBar';
import SortByComponent from './SortByComponent';

const StoreHeader = () => {
  const [store, setStore] = useState([]);
  const [userData, setUserData] = useState(null);
  const [showSearch, setShowSearch] = useState(false);
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState(null);

  useEffect(() => {
    setStore(JSON.parse(localStorage.getItem('selectedStoreData')));
    setUserData(JSON.parse(localStorage.getItem('userDataLogin')));
  }, []);

  const handleProfileClick = () => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/profileScreen');
    } else {
      navigate('/mobileNumber');
    }
  };

  const handleSearchClick = () => {
    setShowSearch((prev) => !prev);
  };

  return (
    <>
      <Box className="storeHeader"
        sx={{
          // backgroundImage: `url(${Images.snowFall})`, 
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
          zIndex: 0,
        }}
      >
        <Box sx={{ display: 'flex' }}>
          <Box>
            <Box onClick={() => navigate('/pickupOutletScreen')} sx={{ padding: '3px 6px', display: 'flex', alignItems: 'center', backgroundColor: '#fff', borderRadius: '16px', border: '1px solid #00A9FC' }}>
              <LocationOnSharp className="storeIcon" />
              <Typography
                sx={{ fontSize: '13px', fontWeight: '500', color: '#0E4961', paddingRight: '5px' }}
              >
                {store?.name}
              </Typography>
              <KeyboardArrowDown sx={{ borderLeft: '1px solid #eee', fontSize: '18px' }} />
            </Box>
          </Box>
        </Box>
        <SortByComponent
          activeFilter={activeFilter}
          onFilterChange={(value) =>
            setActiveFilter((prev) => (prev === value ? "" : value))
          }
        />
        <Box>
          <img onClick={handleSearchClick} src={showSearch ? Images.closeSearch : Images.searchBarImage} alt="" />
        </Box>
      </Box>

      {showSearch && (
        <>
          <Slide direction="down" in={showSearch} mountOnEnter unmountOnExit timeout={300}>
            <Box
              sx={{
              }}
            >
              {showSearch && <SearchBar />}
            </Box>
          </Slide>
        </>
      )}
    </>
  );
};

export default StoreHeader;
